import { useCommonEnum } from './commonEnumStore';
import { useSystemConfig, usePagePerm } from './systemStore';
import { usePageLoading } from './pageLoadingStore';
import { useRouterStatus } from './routerStatusStore';

export * from './commonEnumStore';
export * from './systemStore';
export * from './pageLoadingStore';
export * from './routerStatusStore';

window.__SYSTEM_STORE_HOOK__ = {
  useCommonEnum,
  useSystemConfig,
  usePagePerm,
  usePageLoading,
  useRouterStatus,
};
